import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { remove, updateQty, removeEngraving, updateEngraving } from './actions';
import EmptyState from './EmptyState';
import ListItem from './ListItem';
import { engravingForItem } from 'shared/models/cart';
import { plainList } from 'scy/utils.mod.scss';
import padding from 'scy/padding.mod.scss';

function CartItemList({
  checkout,
  className,
  onClick,
  products = [],
  engravings = [],
  loading,
  remove,
  updateQty,
  removeEngraving,
  updateEngraving
}) {
  return products.length ? (
    <ul className={classnames(plainList, padding.sm, className)}>
      {products.map(item => (
        <ListItem
          key={item.cart_id ? item.cart_id + item.qty : item.sku_id + item.qty}
          item={item}
          engraving={engravingForItem(engravings, item)}
          checkout={checkout}
          loading={loading}
          onClick={onClick}
          remove={remove}
          updateQty={updateQty}
          removeEngraving={removeEngraving}
          updateEngraving={updateEngraving}
        />
      ))}
    </ul>
  ) : (
    <EmptyState className={className} />
  );
}

const ConnectedCartItemList = connect(
  state => ({
    products: state.cart.products,
    engravings: state.cart.engravings,
    loading: state.cart.loading,
    address: state.address
  }),
  { remove, updateQty, removeEngraving, updateEngraving }
)(CartItemList);

export default ConnectedCartItemList;
